import React from 'react'
import PropTypes from 'prop-types'

export function DangerAlert (props) {
  return <mosaic-alert color='danger'>{props.error}</mosaic-alert>
}

DangerAlert.propTypes = {
  error: PropTypes.string
}
